import { AxiosResponse } from "axios";
import API from "../api";
import { ItemJob } from "../models/sales";
import BaseService from "./_base.service";

const endpoint = "items/jobs";

const ItemJobService = {
  ...BaseService<ItemJob>({ endpoint }),

  async getItemStatus(options?: any): Promise<AxiosResponse<any>> {
    return await API.get(`${endpoint}/status`, { params: options });
  },

  async getAll(options?: any): Promise<AxiosResponse<ItemJob[]>> {
    return await API.get(`${endpoint}/list`, { params: options });
  },
  async getInventory(options?: any): Promise<AxiosResponse<any>> {
    return await API.get(`${endpoint}/inventory`, { params: options });
  },
};

export default ItemJobService;
